<template>
    <v-app>
        <v-main>
            <v-container>
                <v-layout justify-center>
                    <v-flex xs12 sm12 md12 lg12 xl12>
                        <v-card>
                            <v-card-title class="pb-5">
                                <!--                                    v-if="$can('transaction_create')"-->
                                <v-btn :to="{name:'payments.index'}" rounded color="#A5668B" class="text-white">
                                    <v-icon>mdi-backspace-reverse-outline</v-icon>
                                    بازگشت
                                </v-btn>
                                <v-spacer/>
                                {{ $route.meta.title }}
                                <v-spacer/>
                                <v-btn @click="updateGateway" :loading="loading" color="#50858B" rounded
                                       class="text-white">
                                    <v-icon>mdi-refresh</v-icon>
                                    ذخیره
                                </v-btn>
                                <!--                            <v-card elevation="2" outlined>-->
                            </v-card-title>


                            <v-card-text>
                                <v-row>
                                    <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                                        <v-text-field
                                            v-model="name"
                                            :error-messages="errors.name"
                                            label="اسم"
                                            required
                                            outlined
                                            dense
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                                        <v-select
                                            v-model="type"
                                            :items="types"
                                            :error-messages="errors.type"
                                            item-text="title"
                                            item-value="value"
                                            label="نوع"
                                            outlined
                                            dense
                                            return-object
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                                        <v-select
                                            v-model="driver"
                                            :items="drivers"
                                            readonly
                                            :error-messages="errors.driver"
                                            item-text="title"
                                            item-value="value"
                                            label="درایور"
                                            outlined
                                            dense
                                            return-object
                                        ></v-select>
                                    </v-flex>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-main>
    </v-app>

</template>

<script>
export default {
    props: ['id'],
    data() {
        return {
            name: '',
            type: null,
            types: [
                {title: 'حقیقی', value: 'regular'},
                {title: 'حقوقی', value: 'legal'},
            ],
            drivers: [
                {title: 'زرینپال', value: 'zarinpal'},
                {title: 'بانک ملت', value: 'behpardakht'},
                {title: 'سامان', value: 'saman'},
            ],
            driver: null,
            errors: {},
            loading: false,
        };
    },

    methods: {
        getGatewayPayment() {
            this.loading = true;
            this.requestApiGet(`gatewayPayment/${this.id}`).then(({data}) => {
                console.log(data)
                this.name = data.name;
                this.type = data.type;
                this.driver = data.driver;
                this.loading = false;
            });
        },

        updateGateway() {
            this.loading = true;
            this.requestApiPost(`gatewayPayment/${this.id}`, {
                name: this.name,
                type: this.type.value,
                _method: 'PUT',

            }).then(({data}) => {
                this.loading = false;
                this.$toast.success('با موفقیت بروزرسانی شد');
                this.$router.push({name: 'payments.index'});
            }).catch(({response}) => {
                this.errors = response.data.errors;
            });
        },

    },
    mounted() {
        this.getGatewayPayment();
    },
};

</script>
